import dayjs from 'dayjs'

// Duration 增加了 .duration .isDuring API 来支持时间长度。
const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

// CustomParseFormat 拓展了 dayjs() 支持自定义时间格式. 参考：https://day.js.org/docs/zh-CN/plugin/custom-parse-format
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

// From now: https://day.js.org/docs/en/display/from-now
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

// Locale: https://day.js.org/docs/en/i18n/loading-into-nodejs
require('dayjs/locale/zh-cn')

/**
 * 时间工具
 */
export default {
  /**
   * dayjs
   * 解决 safari/Firefox 下的兼容问题
   *
   * @param {string|object} t 日期
   * @param {string} s 格式
   * @returns {object} dayjs
   */
  mydayjs(t, s) {
    if (typeof t !== 'string') {
      return dayjs(t, s)
    }

    // 字符串格式
    let ua = navigator.userAgent.toLowerCase()
    let dateStr = /firefox/i.test(ua) // For Firefox browser
      ? t
      : t.replace(/-/g, '/').replace(/T/g, ' ')

    return dayjs(dateStr, s)
  },
  /**
   * 转化为本地的时间
   *
   * @param {string} time ISO 时间
   * @returns {string} 格式化后的时间
   */
  formatFormTime(time) {
    return this.mydayjs(time)
      .locale('zh-cn')
      .fromNow()
  },
  /**
   * 时间区间格式化展示
   *
   * @param {string} beginTime ISO开始时间
   * @param {string} endTime ISO结束时间
   * @returns {string} 区间格式化
   */
  formatDuration(beginTime, endTime) {
    let duration = (this.mydayjs(endTime).valueOf() - this.mydayjs(beginTime).valueOf()) / 1000

    let hours = parseInt(duration / 3600)
    let minutes = parseInt((duration % 3600) / 60)
    let seconds = parseInt((duration % 3600) % 60)

    if (hours >= 24) {
      // days
      let days = parseInt(hours / 24)
      let leftHours = hours % 24
      return `${days} 天 ${minutes > 0 ? leftHours + 1 : leftHours} 小时` // 忽略多出的秒
    } else if (hours > 0) {
      // hours
      return `${hours} 小时 ${seconds > 0 ? minutes + 1 : minutes} 分`
    } else if (minutes > 0) {
      // minutes
      return `${minutes} 分 ${seconds} 秒`
    }
    return `${seconds} 秒`
  }
}
